module.exports = __webpack_public_path__ + "static/time-icon-75947b6f42d125f5b4007311f3be84a8.svg";